import { preloadSourcingWebsiteCounts } from "@/pages/admin-sourcing-websites/api/fetch-sourcing-website-counts-query";
import { preloadSourcingWebsites } from "@/pages/admin-sourcing-websites/api/fetch-sourcing-websites-query";
import type { SourcingWebsitesSearch } from "@/pages/admin-sourcing-websites/model/search-params";

export const preloadSourcingWebsitesQueries = (
  search: SourcingWebsitesSearch,
) => {
  preloadSourcingWebsites(search);
  preloadSourcingWebsiteCounts();
};
